import { render, staticRenderFns } from "./AccountModal.vue?vue&type=template&id=65e5045b&scoped=true&"
import script from "./AccountModal.vue?vue&type=script&lang=ts&"
export * from "./AccountModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e5045b",
  null
  
)

export default component.exports